import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useStateHandler from '@/hooks/useStateHandler';
import GalleryService from '@/services/gallery.service';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import { getAboutErrors, getMediaErrors, getSubmitErrors } from '../../validations';

import './styles/SubmitArtworkDraft.css';

export default function SubmitArtworkDraft({ formState, setFormError, termsAccepted, allFieldsFilled }) {
  const { cacheHandler } = useStateHandler();
  const [loading, setLoading] = useState(false);
  const [openGenericPopup, setOpenGenericPopup] = useState(false);
  const [hasGenericErrors, setHasGenericErrors] = useState(false);
  const navigate = useNavigate();

  async function validations() {
    setFormError(null);

    const aboutErrors = getAboutErrors(formState);
    const mediaErrors = getMediaErrors(formState);
    const errors = getSubmitErrors(termsAccepted, formState);

    // if about or media has errors, set the generic error flag
    if (aboutErrors.length > 0 || mediaErrors.length > 0) {
      setHasGenericErrors(true);
      return;
    } else {
      setHasGenericErrors(false);
    }

    if (errors.length > 0) {
      setFormError(errors);
      return false;
    }

    return true;
  }

  async function submitArtworkDraft(event) {
    event.preventDefault();
    if (!await validations()) return;
    
    const { response, data } = await GalleryService.saveArtworkDraft(formState, { about: true, media: true, shipping: true });

    if (response.ok) {
      setOpenGenericPopup(true);     
    } else if (response.status === 400) {
      setLoading(false);
      setFormError([{ element: data.error_data.element, error_code: data.error_type }]);
    }
  }

  function backToInventory() {
    setOpenGenericPopup(false);
    setLoading(false); 
    cacheHandler.triggerAction("NEW_ARTWORK_REQUEST");
    navigate('/inventory/pending', { replace: true });
  }

  function backToProfile() {
    setOpenGenericPopup(false);
    setLoading(false); 
    cacheHandler.triggerAction("NEW_ARTWORK_REQUEST");
    navigate('/profile', { replace: true });
  }

  return (
    <>
      <div className="add-artwork-form-submit_button">
        <ContinueButton 
          onClick={submitArtworkDraft} 
          loading={loading} 
          disabled={loading || !allFieldsFilled}
        >
          Submit artwork
        </ContinueButton>
        {
          hasGenericErrors && (
            <span className="submit-artwork-form__error-message">
              Complete all fields before submitting
            </span>
          )
        }
      </div>

      <GenericPopup className="artwork-confirmation-dialog remove-scrollbar" open={openGenericPopup} opacity>
        <Text className="add-artwork-form__confirmation-text-header" paragraph >
          Submission received!
        </Text>

        <Text className="add-artwork-form__confirmation-text" paragraph small>
          Once accepted, the artwork will appear in your profile. You can check its submission status in your inventory at any time.
        </Text>
        <div className="submit-artwork-confirmation-dialog__action-buttons">
          <ContinueButton 
            onClick={backToInventory}
            className="submit-artwork-confirmation-dialog__button continue-button_two"
          >
            Visit inventory
          </ContinueButton>
          <ContinueButton 
            onClick={backToProfile}
            className="submit-artwork-confirmation-dialog__button continue-button_two"
          >
            Go to profile
          </ContinueButton>
        </div>
      </GenericPopup>
    </>
  );
}
